// 既読の記事。端末ローカル保存（localStorage・サーバー非同期）。
//
// 「クッションを開いた」＝能動的に中身を確認した、という記録。
// 外部サイトへ遷移したかどうかは問わない（記事を読んだかは追えないし、
// 見出しと概要を見て判断したなら、それも確認済みでよい）。
//
// **記事IDしか持たない。** ブックマークと違い表示に使うのは真偽値だけなので、
// スナップショットを持つ必要がない。1件7バイト程度で、上限2000件でも約14KB。
//
// 期限は付けず件数だけで打ち切る。フィード自体が
// 新着500件 / 話題72時間 / マイゲーム90日 で頭打ちなので、
// それより古い既読情報は参照されることがない。

const KEY = 'news_seen_v1';

// 新しい順に保持する上限。超えた分は古いものから捨てる
const MAX_ITEMS = 2000;

const read = (): number[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((n) => typeof n === 'number') : [];
  } catch {
    return [];
  }
};

const write = (ids: number[]): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX_ITEMS)));
  } catch {
    /* localStorage 利用不可・容量超過時は黙って無視 */
  }
};

/** 判定は Set で行う。カード1枚ごとに配列を走査すると一覧全体で O(n^2) になる */
export const readSeenIds = (): Set<number> => new Set(read());

/**
 * 既読にする。既に既読なら書き込まない
 * （同じ記事を開き直すたびに localStorage を書くのは無駄）。
 * 戻り値は更新後の集合。変化が無ければ渡された集合をそのまま返す。
 */
export const markSeen = (articleId: number, current: Set<number>): Set<number> => {
  if (current.has(articleId)) return current;
  const ids = read().filter((id) => id !== articleId);
  write([articleId, ...ids]);
  return new Set([articleId, ...ids].slice(0, MAX_ITEMS));
};

/**
 * 指定した記事だけ既読から外す。
 *
 * 既読は記事IDの集合でしかなく、どのタブで見たかは持っていない
 * （同じ記事が話題にも新着にも出るので、タブに属させようがない）。
 * 「今表示している一覧の既読を消す」はこれで実現する。
 */
export const unmarkSeen = (articleIds: number[]): Set<number> => {
  const remove = new Set(articleIds);
  const next = read().filter((id) => !remove.has(id));
  write(next);
  return new Set(next);
};

/** 既読をすべて消す */
export const clearSeen = (): Set<number> => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* 無視 */
  }
  return new Set();
};
